(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dori-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const sectionId = '{{ section.id }}';
  const section   = document.getElementById('dori-hero-' + sectionId);
  if (!section) return;

  const parallax      = document.getElementById('dori-hero-parallax-' + sectionId);
  const scrollOverlay = document.getElementById('dori-hero-scroll-overlay-' + sectionId);

  if (!parallax || !scrollOverlay) return;

  let ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHero);
      ticking = true;
    }
  }

  function updateHero() {
    const rect         = section.getBoundingClientRect();
    const sectionTop   = rect.top;
    const sectionH     = rect.height;

    // Only animate while section is in view
    if (sectionTop > window.innerHeight || sectionTop + sectionH < 0) {
      ticking = false;
      return;
    }

    // scrollYProgress: 0 (section top at viewport top) → 1 (section bottom at viewport top)
    // Matches: offset: ['start start', 'end start']
    const scrolled       = -sectionTop;                    // px scrolled into section
    const scrollProgress = Math.max(0, Math.min(1, scrolled / sectionH));

    // Parallax — imgY = useTransform(scrollYProgress, [0,1], ['0%','25%'])
    // 25% of section height in px
    const imgY = scrollProgress * sectionH * 0.25;
    parallax.style.transform = 'translateY(' + imgY + 'px)';

    // Overlay opacity — useTransform(scrollYProgress, [0, 0.5], [0.5, 0.8])
    const progress    = Math.min(scrollProgress / 0.5, 1);   // clamp at 0.5 progress
    const overlayOpacity = 0.5 + (progress * 0.3);           // 0.5 → 0.8
    scrollOverlay.style.setProperty('--scroll-overlay-opacity', overlayOpacity.toFixed(3));
    scrollOverlay.style.opacity = overlayOpacity.toFixed(3);

    ticking = false;
  }

  // Passive scroll for performance
  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial call on load
  updateHero();

  // Shopify theme editor hot-reload cleanup
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail.sectionId === sectionId) {
      window.removeEventListener('scroll', onScroll);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dori-split-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sectionId = '{{ section.id }}';
  var section = document.getElementById('dori-split-editorial-' + sectionId);
  if (!section) return;

  /* ── Parallax effect {%- endcomment -%} */
  var imageArea = section.querySelector('[data-dori-parallax]');
  if (!imageArea) return;

  var stacks = imageArea.querySelectorAll('[data-parallax-speed]');
  if (stacks.length === 0) return;

  var ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function updateParallax() {
    var rect = section.getBoundingClientRect();
    var sectionTop = rect.top;
    var sectionHeight = rect.height;
    var windowH = window.innerHeight;

    // Only animate while section is in view
    if (sectionTop > windowH || sectionTop + sectionHeight < 0) {
      ticking = false;
      return;
    }

    // scrollYProgress: 0 (section top at viewport bottom) → 1 (section bottom at viewport top)
    // Matches: offset: ['start end', 'end start']
    var scrolled = windowH - sectionTop;
    var scrollProgress = Math.max(0, Math.min(1, scrolled / sectionHeight));

    stacks.forEach(function (stack) {
      var speed = parseFloat(stack.getAttribute('data-parallax-speed'));
      var yOffset = scrollProgress * speed;
      stack.style.transform = 'translateY(' + yOffset + 'px)';
    });

    ticking = false;
  }

  // Passive scroll for performance
  window.addEventListener('scroll', onScroll, { passive: true });

  // Initial call on load
  updateParallax();

  /* ── IntersectionObserver for scroll-reveal {%- endcomment -%} */
  var content = section.querySelector('[data-dori-reveal]');
  if (content) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: "-50px" });

    observer.observe(content);
  }

  /* ── Shopify theme editor hot-reload cleanup {%- endcomment -%} */
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail.sectionId === sectionId) {
      window.removeEventListener('scroll', onScroll);
      if (content) {
        content.classList.remove('is-visible');
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dori-wardrobe-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var sectionId = '{{ section.id }}';
  var section = document.getElementById('dori-wardrobe-' + sectionId);
  if (!section) return;

  /* ── IntersectionObserver for stagger animation  */
  var items = section.querySelectorAll('[data-dori-reveal]');

  // Check if elements are already in view on page load
  items.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var isCurrentlyVisible = rect.top < windowHeight && rect.bottom > 0;

    if (isCurrentlyVisible) {
      var delay = el.getAttribute('data-dori-delay');
      if (delay) {
        setTimeout(function () {
          el.classList.add('is-visible');
        }, parseFloat(delay) * 1000);
      } else {
        el.classList.add('is-visible');
      }
    }
  });

  // Observer for elements that scroll into view later
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-dori-delay');
        if (delay) {
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, parseFloat(delay) * 1000);
        } else {
          entry.target.classList.add('is-visible');
        }
      }
    });
  }, { threshold: 0.1, rootMargin: "-50px" });

  items.forEach(function (el) {
    observer.observe(el);
  });

  /* ── Shopify theme editor hot-reload cleanup  */
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail.sectionId === sectionId) {
      var targets = section.querySelectorAll('[data-dori-reveal]');
      targets.forEach(function (el) {
        el.classList.remove('is-visible');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
